var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 7,
    fill: "#FF5A52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.333 16.1667H19.833V10.6667C19.833 9.65466 19.0117 8.83333 17.9997 8.83333C16.9877 8.83333 16.1663 9.65466 16.1663 10.6667V16.1667H10.6663C9.65434 16.1667 8.83301 16.988 8.83301 18C8.83301 19.012 9.65434 19.8333 10.6663 19.8333H16.1663V25.3333C16.1663 26.3453 16.9877 27.1667 17.9997 27.1667C19.0117 27.1667 19.833 26.3453 19.833 25.3333V19.8333H25.333C26.345 19.8333 27.1663 19.012 27.1663 18C27.1663 16.988 26.345 16.1667 25.333 16.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon_plus.bc452194c05c226d26f3815a7a7de4db.svg";
export { ForwardRef as ReactComponent };